import { Clock3 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { extractDeliveryEstimate, formatDeliveryEstimateDate } from '@/utils/deliveryEstimate';

const DeliveryEstimateSummary = ({
  source,
  title = 'Délai estimé',
  variant = 'panel',
  className,
  testId,
}) => {
  const estimate = extractDeliveryEstimate(source);

  if (!estimate) {
    return null;
  }

  const formattedDate = formatDeliveryEstimateDate(estimate.estimatedDeliveryDate);

  if (variant === 'compact') {
    return (
      <div data-testid={testId} className={cn('flex flex-col gap-1', className)}>
        {estimate.label ? <Badge variant="outline">{estimate.label}</Badge> : null}
        {formattedDate ? (
          <p className="text-xs text-gray-500">ETA {formattedDate}</p>
        ) : null}
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className={cn('rounded-xl border border-cyan-100 bg-cyan-50 p-4', className)}
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-cyan-700">{title}</p>
      <div className="mt-2 flex items-center gap-2">
        <Clock3 className="h-4 w-4 text-cyan-700" />
        <p className="font-semibold text-cyan-950">{estimate.label || 'Estimation disponible'}</p>
      </div>
      {formattedDate ? (
        <p className="mt-1 text-sm text-cyan-900">Livraison estimée le {formattedDate}</p>
      ) : null}
    </div>
  );
};

export default DeliveryEstimateSummary;
